<template>
  <div>
    <el-table
v-loading="loading"
:data="data"
size="small">
      <el-table-column
label="STT"
width="80"
fixed="left"
align="center">
        <template slot-scope="scope">
          <span>
            {{ scope.row.stt }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="field in fields"
        :key="field.key"
        :prop="field.key"
        :label="field.label"
        :width="field.width"
      >
        <template slot-scope="scope">
          <span v-if="field.key === 'created'">
            {{ scope.row[field.key] | convertDateTime("HH:mm DD/MM/YYYY") }}
          </span>
          <span v-else-if="field.key === 'name'">
            {{
              scope.row.translations.vi ? scope.row.translations.vi.name : ""
            }}
          </span>
          <span v-else-if="field.key === 'description'">
            {{
              scope.row.translations.vi
                ? scope.row.translations.vi.description
                : ""
            }}
          </span>
          <span v-else>
            {{ scope.row[field.key] }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="Thao tác"
        width="120"
        fixed="right"
        align="center"
      >
        <template slot-scope="scope">
          <el-row
type="flex"
justify="center">
            <el-tooltip
content="Sửa"
effect="dark"
placement="top">
              <el-button
                icon="el-icon-edit"
                type="primary"
                size="small"
                circle
                @click="() => $emit('update', scope.row)"
              />
            </el-tooltip>
            <el-tooltip
content="Xoá"
effect="dark"
placement="top">
              <el-button
                icon="el-icon-delete"
                type="danger"
                size="small"
                circle
                @click="() => $emit('delete', scope.row)"
              />
            </el-tooltip>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import CONSTANTS from "@/config/constants";

export default {
  name: "CardList",
  components: {},
  props: {
    data: Array,
    loading: Boolean,
  },
  data() {
    return {
      fileType: CONSTANTS.FILE_TYPE,
    };
  },
  computed: {
    fields() {
      return [
        {
          key: "code",
          label: "Mã quyền",
        },
        {
          key: "name",
          label: "Tên quyền",
        },
        {
          key: "description",
          label: "Mô tả",
        },
        {
          key: "created",
          label: "Ngày tạo",
        },
      ];
    },
  },
  methods: {
    //
  },
};
</script>

<style lang="scss"></style>
